import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useDialog, useRequestState, useSearch } from '@app/hooks';
import { useTable } from '@app/components/table';
import { useAuthRolePermissions } from '@app/utils';
import { TestimonialList } from './testimonial-list';
import { AddTestimonial } from './add-testimonial';
import { getTestimonial } from '../slice';
import { selectTestimonialState } from '../selector';

export const TestimonialPage = () => {
  const addTesimonialDialog = useDialog();
  const tableProps = useTable();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTestimonial());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectTestimonialState,
    errorShown: true,
  });

  const searchProps = useSearch({
    data,
    fields: ['projectName', 'client.firstName', 'client.lastName', 'clientId'],
  });
  const { hasPermission } = useAuthRolePermissions();
  const canAddTestimonial = hasPermission('Testimonial', 'w');

  return (
    <>
      <Header
        title={Strings.clients.clientTestimonial}
        helperText={''}
        actionButtonTitle={Strings.clients.addTestimonial}
        onClickActionButton={addTesimonialDialog.show}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <TestimonialList
        tableProps={tableProps}
        rows={searchProps.filteredRows}
        loading={loading}
        canAddTestimonial={canAddTestimonial}
      />
      {addTesimonialDialog.visible && <AddTestimonial open onClose={addTesimonialDialog.hide} />}
    </>
  );
};
